import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Container, Grid } from 'semantic-ui-react';

import { APP_NAME } from '../../utils/constant';
import { getForgotVerification, resetPassword } from '../../store/actions';
import PasswordChange from '../../components/passwordChange';

import './auth.scss';

class ResetPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.reset_password')} | ${APP_NAME}`;
    try {
      const {
        getForgotVerification,
        match: {
          params: { id = null },
        },
        navigate,
      } = this.props;
      await getForgotVerification(id, navigate);
    } catch (error) {
      console.error(error);
    }
  }

  async handleValidSubmit(values) {
    const {
      resetPassword,
      match: {
        params: { id = null },
      },
      navigate,
    } = this.props;
    await resetPassword(
      {
        token: id,
        password: values.password,
      },
      navigate
    );
  }

  render() {
    const { t, resetPassLoading } = this.props;
    return (
      <Grid.Row>
        {/* <Grid.Column mobile={16} tablet={16} computer={8} />
        <Grid.Column mobile={16} tablet={16} computer={8}> */}
        <Container className="right-heading-container">
          {/* <div className="heading-row"> */}
          <label className="headerText">{t('auth.reset_password.title')}</label>
          <br></br>
          <>
            <label className="headerDescription">
              {t('auth.reset_password.description')}
            </label>

            <div className="w-85">
              <PasswordChange
                isFromForgotPassword={true}
                loading={resetPassLoading}
                handleValidSubmit={(values) => {
                  this.handleValidSubmit(values);
                }}
              />

              <Link to={'/signin'}>
                <label className={'goBackSignIn'}>
                  {t('auth.reset_password.button')}
                </label>
              </Link>
            </div>
          </>
          {/* )} */}
          {/* </div> */}
        </Container>
        {/* </Grid.Column> */}
        {/* <Grid.Column mobile={16} tablet={5} computer={5} /> */}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getForgotVerification,
      resetPassword,
    },
    dispatch
  );
};

ResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ResetPassword));

export default ResetPassword;
